<template>
  <PageTemplate>
    <div class="pb-8">
      <About />
      <Directors />
      <Specialties />
      <Structure />
      <HospitalizationGuide />
      <Recycle />
    </div>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import About from "./About.vue";
import Directors from "./Directors.vue";
import Specialties from "../../templates/Specialties.vue";
import Structure from "./Structure.vue";
import HospitalizationGuide from "./HospitalizationGuide.vue";
import Recycle from "./Recycle.vue";

export default {
  components: {
    PageTemplate,
    About,
    Directors,
    Specialties,
    Structure,
    HospitalizationGuide,
    Recycle,
  },
};
</script>
